import SlideShow from "../Reusable Elements/SlideShow";
import { Mail } from "../Icons/Mail";
import { Phone } from "../Icons/Phone";
import { Location } from "../Icons/Location";
import { contactImages } from "../../data/slideShowData";

const Contact = () => {
    return (
        <div className="flex w-screen items-center justify-between sm:flex-row pt-7 sm:pb-7 flex-col-reverse">
            <div>
                <SlideShow side={"left"} images={contactImages} />
            </div>
            <div className="flex flex-col sm:pl-10 sm:pr-14 sm:w-[60vw] px-2 items-center gap-y-12 mb-10 sm:mb-0">
                <div className="w-fit flex items-center flex-col">
                    <div className="font-poppins font-light text-4xl text-center text-primary-gold">
                        Contact
                    </div>
                    <div className="font-poppins text-lg font-extralight text-center mt-1">
                        Get in touch with us today
                    </div>
                </div>
                <div className="w-fit flex items-center flex-col">
                    <div className="font-poppins font-light text-4xl text-center text-primary-gold">
                        <Mail
                            style={{ fontSize: "25px", marginRight: "15px" }}
                        />
                        Email
                    </div>
                    <a
                        className="font-poppins text-lg font-extralight text-center mt-1 underline cursor-pointer"
                        href="mailto:sultanahomes@gmail.com"
                    >
                        <div>sultanahomes@gmail.com</div>
                    </a>
                </div>
                <div className="w-fit flex items-center flex-col">
                    <div className="font-poppins font-light text-4xl text-center text-primary-gold">
                        <Phone
                            style={{ fontSize: "25px", marginRight: "15px" }}
                        />
                        Call
                    </div>
                    <a
                        className="font-poppins text-lg font-extralight text-center mt-1 underline cursor-pointer"
                        href="tel:+923111266555"
                    >
                        <div>+923 111 266 555</div>
                    </a>
                </div>
                <div className="w-fit flex items-center flex-col">
                    <div className="font-poppins font-light text-4xl text-center text-primary-gold">
                        <Location
                            style={{ fontSize: "10px", marginRight: "15px" }}
                        />
                        Visit Today
                    </div>
                    <a
                        target="_blank"
                        href="https://maps.app.goo.gl/gutLSnmpjhHiDpd29"
                        rel="noreferrer"
                        className="font-poppins text-lg font-extralight mt-1 text-center underline cursor-pointer w-[80%]"
                    >
                        <div>
                            Adjacent Tariq Garden, Near Valencia Town,
                            Khayaban-e-Jinnah Road, Lahore
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Contact;
